import { FC, PropsWithChildren } from 'react';
import { createContext } from '@/utils/context';
import { langDictionary } from '@/type/context';
import { info } from '@/utils/safetyLog';
import { useSelectedCategory } from '../use- selectcategory';
import { useArea } from '../use-areakey';

export interface AppContextProps {
  langDictionary: langDictionary;
  headerFooter: any;
  featureConfigData: any;
  blogFeatureConfigData: any;
  page: any;
  language: {
    label: 'zh-hk' | 'en-us';
    value: 'zh' | 'en';
    origin: 'zh' | 'en';
  };
}

export interface ProviderProps {
  langDictionary: langDictionary;
  headerFooter: any;
  featureConfigData: any;
  blogFeatureConfigData: any;
  areaKey: string;
  setAreaKey: any;
  selectedCategory: string;
  setSelectedCategory: any;
  page: any;
  language: {
    label: 'zh-hk' | 'en-us';
    value: 'zh' | 'en';
    origin: 'zh' | 'en';
  };
}

const [Provider, useContext] = createContext<ProviderProps>({
  name: 'AppContext'
});

export const AppProvider: FC<PropsWithChildren<AppContextProps>> = ({
  children,
  ...initialValues
}) => {
  const { areaKey, setAreaKey } = useArea();
  const { selectedCategory, setSelectedCategory } = useSelectedCategory();
  const values = {
    ...initialValues,
    areaKey,
    setAreaKey,
    selectedCategory,
    setSelectedCategory,
    headerFooter: initialValues.headerFooter,
    featureConfigData: initialValues.featureConfigData,
    blogFeatureConfigData: initialValues.blogFeatureConfigData,
    page: initialValues.page,
    language: initialValues.language
  };
  return <Provider value={values}>{children}</Provider>;
};

export const useAppContext = useContext;
